import { render, staticRenderFns } from "./ChangeDepartamentModal.vue?vue&type=template&id=2c5cd78c&scoped=true&"
import script from "./ChangeDepartamentModal.vue?vue&type=script&lang=js&"
export * from "./ChangeDepartamentModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDepartamentModal.vue?vue&type=style&index=0&id=2c5cd78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cd78c",
  null
  
)

export default component.exports